import React from "react";
import { useDispatch } from "react-redux";
import { updateAppFontSize, updateAppContrast } from "../actions";
const ICON_FONT_SIZE = require("../assets/format_size.svg");
const ICON_TONALITY = require("../assets/tonality.svg");
const VISIT_USTKA = require("../assets/visit_ustka.png");

const ContrastBtn = () => {
  const dispatch = useDispatch();

  const updateFontSize = () => dispatch(updateAppFontSize());
  const updateContrast = () => dispatch(updateAppContrast());

  return (
    <div className="w-100 text-right">
      <div className="col-12 mt-2 mt-md-3 mt-lg-0">
        <button onClick={updateFontSize} className="btn btn-link p-1" title="Zmień wielkość czcionki">
          <img src={ICON_FONT_SIZE} alt="Zmień wielkość czcionki" />
        </button>
        <button onClick={updateContrast} className="btn btn-link p-1" title="Zmień kontrast">
          <img src={ICON_TONALITY} alt="Zmień kontrast" />
        </button>
        <a target="_blank" href="https://visit.ustka.pl/" className="ml-3" title="Odwiedź (nowe okno przeglądarki) Visit Ustka">
          <img alt="Visit Ustka" src={VISIT_USTKA} className="visit-ustka-img" />
        </a>
      </div>
    </div>
  );
};

export default ContrastBtn;



// WEBPACK FOOTER //
// ./src/screens/ContrastBtn.js